export default "__VITE_ASSET__c1bc3f68__"